// extracted by mini-css-extract-plugin
module.exports = {"root":"CNDownloadPage_root__2X7Ib","content":"CNDownloadPage_content__2NThp","img":"CNDownloadPage_img__1w68W"};